<template>
  <div v-if="filteredBrandsGroup.length" class="mb-3">
    <h1 :id="`b_${letter}`" class="text-uppercase mb-1">{{ letter }}</h1>
    <div class="row">
      <div
        v-for="(group, index) in filteredBrandsGroup"
        :key="`brandGroup-${index}`"
        class="col-12 col-sm-8 col-md-6 col-lg-4"
      >
        <a
          :href="brand.link"
          v-for="brand in group"
          :key="brand.name"
          class="mb-1 text-sm text-dark d-block bd-Name"
        >
          {{ brand.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BrandListing",
  components: {},
  props: {
    entry: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      letter: this.entry[0],
      brands: this.entry[1],
      groupSize: 6,
    };
  },
  computed: {
    ...mapGetters({
      brandFilter: "brand/brandFilter",
    }),
    filteredBrandsGroup() {
      const result = [];
      const brands = this.brands.filter(brand => {
        return brand.name.toLowerCase().includes(this.brandFilter.toLowerCase());
      });
      for (let i = 0; i < brands.length; i += this.groupSize) {
        result.push(brands.slice(i, i + this.groupSize));
      }
      return result;
    },
  },
};
</script>
